import { AxiosError } from 'axios';
import { api } from '.';
import routes from '../../routes';

interface ErrorResponse {
    error: boolean,
    status?: number,
    redirect: string,
    statusText?: string,
}

export function isErrorRedirect(error: any): error is ErrorResponse {
    return (
        typeof error === 'object' &&
        error !== null &&
        'redirect' in error &&
        error.redirect.length > 1
    );
}

const responseInter = () => {
    api.interceptors.response.use(
        (response) => {
            return response;
        },
        (error: AxiosError) => {
            const response = error.response;

            const errorResponse: ErrorResponse = {
                error: true,
                status: response?.status,
                redirect: '',
                statusText: response?.statusText,
            };

            if (response?.status === 403 || response?.status === 401) {
                console.error(`error response status: ${response.status}; ref: ${window.location.pathname}`);
                // we are clearing trace in unableToProcessRequestPage
                errorResponse.redirect = routes.unableToProcessRequestPage.path;
            } else {
                errorResponse.redirect = `/error/${response?.status}`;
            }

            return new Promise((_, reject) => {
                reject(errorResponse);
            });
        }
    );
};

export default responseInter;
